import React from 'react'

const ZonesSubcategory: React.FC = () => (
  <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="70" height="70" rx="14.5455" fill="url(#paint0_linear_4461_1509)" />
    <path
      d="M35.1546 19.0032C33.9829 19.1203 32.8113 19.1789 31.6982 19.4718C22.2664 21.9323 18.1657 33.1215 24.434 40.6787C27.2459 44.0764 30.5266 47.0641 33.6314 50.2276C34.6859 51.3407 35.6232 51.2235 36.7949 50.0518C39.3725 47.5328 41.9501 45.0138 44.4106 42.3775C46.8125 39.9171 48.2185 36.9294 48.5114 33.473C49.2144 26.033 42.946 18.8274 35.1546 19.0032ZM35.0374 35.7577C32.8699 35.7577 31.171 34.0003 31.171 31.8913C31.171 29.7237 32.9284 28.0248 35.0374 28.0248C37.205 28.0248 38.9038 29.7823 38.9038 31.8913C38.9038 34.0588 37.205 35.7577 35.0374 35.7577Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_4461_1509"
        x1="34.5455"
        y1="0"
        x2="34.5455"
        y2="70"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF005C" />
        <stop offset="1" stopColor="#BD0044" />
      </linearGradient>
    </defs>
  </svg>
)

export default ZonesSubcategory
